import React, { useState } from 'react';
import TestHeader from './components/TestHeader';
import QuestionCard from './components/QuestionCard';
import ActionButtons from './components/ActionButtons';
import TestResults from './components/TestResults';
import { questionPairs, loveLangKey } from './data/questionData';
import { generatePDF } from './utils/pdfGenerator';

const SzeretetnyelvTeszt = () => {
  const [selections, setSelections] = useState(Array(questionPairs.length).fill(null));
  const [showResults, setShowResults] = useState(false);

  const selectOption = (qIdx, optIdx) => {
    const newSelections = [...selections];
    newSelections[qIdx] = optIdx;
    setSelections(newSelections);
  };

  const evaluateResults = () => {
    const scores = { A: 0, B: 0, C: 0, D: 0, E: 0 };
    
    selections.forEach((sel, idx) => {
      if (sel !== null) {
        const letterCode = loveLangKey[idx][sel];
        scores[letterCode]++;
      }
    });

    const numericScores = [scores.A, scores.B, scores.C, scores.D, scores.E];
    const maxScore = Math.max(...numericScores);
    const bestLangs = [];
    numericScores.forEach((val, lidx) => {
      if (val === maxScore) bestLangs.push(lidx);
    });

    return { scores: numericScores, maxScore, bestLangs, letterScores: scores };
  };

  const handleEvaluate = () => {
    setShowResults(true);
    setTimeout(() => {
      document.getElementById('results')?.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const handleSavePDF = () => {
    const { scores, maxScore, bestLangs, letterScores } = evaluateResults();
    generatePDF(questionPairs, selections, scores, maxScore, bestLangs, letterScores);
  };

  const { scores, maxScore } = showResults ? evaluateResults() : { scores: [], maxScore: 0 };

  return (
    <div 
      className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4"
      style={{ fontFamily: 'Comfortaa, sans-serif' }}
    >
      <TestHeader />

      <div className="max-w-5xl mx-auto space-y-8">
        {questionPairs.map((pair, idx) => (
          <QuestionCard
            key={idx}
            questionPair={pair}
            questionIndex={idx}
            selectedOption={selections[idx]}
            onSelectOption={selectOption}
          />
        ))}
      </div>

      <ActionButtons 
        onEvaluate={handleEvaluate}
        onSavePDF={handleSavePDF}
        showResults={showResults}
      />

      {showResults && (
        <TestResults 
          scores={scores} 
          maxScore={maxScore}
        />
      )}
    </div>
  );
};

export default SzeretetnyelvTeszt;